var map = {
	"./beep-08b.mp3": "5742",
	"./fonts/MyriadPro-Regular.otf": "3229",
	"./fonts/ufonts.com_klavika-bold-opentype.otf": "628f",
	"./fonts/ufonts.com_klavika-medium-opentype.otf": "f893",
	"./fonts/ufonts.com_klavika-mediumitalic-opentype.otf": "bab0",
	"./fonts/ufonts.com_klavika-regular-opentype.otf": "eaac",
	"./img/app-store-badge.svg": "0bc4",
	"./img/fondo.jpg": "d133",
	"./img/google-play-badge.svg": "5c91",
	"./img/logo-web-video-mini.png": "49ec",
	"./img/logo.png": "4ffd",
	"./img/logo_evento.png": "9ac9",
	"./img/photo.jpg": "1e22",
	"./img/wapp.png": "7381",
	"./media/cafecito.mp4": "1e79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";